module.exports = __webpack_public_path__ + "img/footer-bg-new.1ee6f6e3.svg";